import React from 'react';

// Agent 模板类型定义
export interface AgentTemplate {
  id: string;
  icon: string; // emoji
  title: string;
  tags?: string[];
  description: string;
  prompt?: string;
  isCustom?: boolean; // 是否为自定义模板（样式不同）
}

interface TemplateSelectorProps {
  templates: AgentTemplate[];
  onSelect: (template: AgentTemplate) => void;
}

const TemplateSelector: React.FC<TemplateSelectorProps> = ({ templates, onSelect }) => {
  return (
    <div className="w-full">
      {/* 标题区 */}
      <div className="text-[20px] font-semibold text-[#333333] mb-2 flex items-center gap-2">
        <span>&#10024;</span>
        <span>Choose a template to start</span>
      </div>
      <div className="text-[14px] text-[#999999] mb-8">
        You can choose a preset persona template, or start from scratch to fully customize.
      </div>

      {/* 模板网格 */}
      <div className="grid grid-cols-1 md:grid-cols-[repeat(auto-fill,minmax(320px,1fr))] gap-5 md:gap-[20px]">
        {templates.map((template) => (
          <div
            key={template.id}
            onClick={() => onSelect(template)}
            className={`
              bg-white p-6 md:p-[24px] rounded-[16px] cursor-pointer
              transition-all duration-[0.3s] ease-[cubic-bezier(0.4,0,0.2,1)]
              flex flex-col gap-4
              ${
                template.isCustom
                  ? 'border border-dashed border-[#999999] bg-transparent hover:border-[#666666]'
                  : 'border border-[#EBEBEB] hover:shadow-[0_8px_24px_rgba(0,0,0,0.04)] hover:-translate-y-[4px] hover:border-[#DCDCDC]'
              }
            `}
          >
            {/* 卡片头部：icon + title + tags */}
            <div className="flex items-center gap-4">
              {/* 模板图标 */}
              <div
                className={`
                  w-12 h-12 rounded-[12px] flex items-center justify-center
                  text-[24px] shrink-0
                  ${
                    template.isCustom
                      ? 'bg-white border border-dashed border-[#DCDCDC]'
                      : 'bg-[#F5F5F7]'
                  }
                `}
              >
                {template.icon}
              </div>

              {/* 标题和标签 */}
              <div className="flex-1 min-w-0">
                <div className="font-semibold text-[17px] text-[#333333] mb-1">
                  {template.title}
                </div>
                {template.tags && template.tags.length > 0 && (
                  <div className="flex gap-[6px] overflow-hidden">
                    {template.tags.slice(0, 4).map((tag, index) => (
                      <span
                        key={index}
                        className="text-[11px] text-[#999999] bg-[#F0F0F0] px-[8px] py-[2px] rounded-[10px] whitespace-nowrap shrink-0"
                      >
                        {tag}
                      </span>
                    ))}
                    {template.tags.length > 4 && (
                      <span className="text-[11px] text-[#999999] px-[4px] shrink-0">
                        ···
                      </span>
                    )}
                  </div>
                )}
              </div>
            </div>

            {/* 描述文字 */}
            <div className="text-[14px] text-[#999999] leading-[1.6]">
              {template.description}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TemplateSelector;